import React from 'react';
import { useFeatureAccess } from '@/components/billing/FeatureGate';
import { PremiumContentWrapper } from '@/components/billing/PremiumContentWrapper';
import { Hive360SettingsPanel } from '@/components/hive360';

export default function Hive360Settings() {
  const { hasAccess } = useFeatureAccess('hive360');

  return (
    <PremiumContentWrapper hasAccess={hasAccess} featureName="Hive360">
      <Hive360SettingsPanel />
    </PremiumContentWrapper>
  );
}